export default function HoverFace() {
  return (
    <img src={process.env.PUBLIC_URL + "/images/10Juillet-eHover.jpg"} alt="" />
  );
}
